module.exports = __webpack_public_path__ + "img/n2.fa55dc3e.svg";